import { useState } from "react";
import { Header } from "./Header";
import { Footer } from "./Footer";
import { FloatingButtons } from "./FloatingButtons";
import { AdmissionFormDialog } from "../forms/AdmissionFormDialog";

export const Layout = ({ children }) => {
  const [isAdmissionFormOpen, setIsAdmissionFormOpen] = useState(false);

  return (
    <div className="min-h-screen flex flex-col">
      <Header onOpenAdmissionForm={() => setIsAdmissionFormOpen(true)} />
      <main className="flex-1">{children}</main>
      <Footer />
      <FloatingButtons />
      <AdmissionFormDialog 
        isOpen={isAdmissionFormOpen} 
        onClose={() => setIsAdmissionFormOpen(false)} 
      />
    </div>
  );
};
